import React from "react";
import { Page, Text, View, Document, Image, StyleSheet } from "@react-pdf/renderer";
import ficha from "../img/ficha.png";

// --- MODULARIZACIÓN DE ESTILOS (DRY) ---
const absoluteText = { position: "absolute", left: "5.75cm", fontSize: "10px" };
const convenioBase = { position: "absolute", left: "1.5cm", fontSize: "8px" };
const flexRow = { display: "flex", flexDirection: "row", justifyContent: "space-between" };

const styles = StyleSheet.create({
  page: { margin: "0", padding: "0" },
  back: { zIndex: "-1", position: "absolute", width: "100%", height: "100%" },
  
  name: { ...absoluteText, top: "5cm" },
  campus: { ...absoluteText, top: "6.7cm" },
  code: { ...absoluteText, top: "6.7cm", left: "13.3cm" }, 
  
  // Agregamos ambos convenios en el lateral izquierdo
  convenioBBVA: { ...convenioBase, top: "11.2cm" },
  convenioBanorte: { ...convenioBase, top: "12.4cm" },
  
  section: { position: "absolute", top: "12cm", left: "5.75cm", fontSize: "8px", width: "14.5cm" },
  
  section2: { ...flexRow, marginBottom: "10px" },
  section2Titles: { ...flexRow, marginBottom: "10px", color: "#bbbdbf", textTransform: "uppercase" },
  
  concepto: { width: "5.5cm", marginLeft: "10px" },
  precio: { width: "2cm", textAlign: "left" },

  // --- ESTILOS NUEVOS PARA APILAR LAS REFERENCIAS ---
  referenciasContenedor: { width: "7cm", display: "flex", flexDirection: "column" },
  bancoTitulo: { fontFamily: "Helvetica-Bold", fontSize: "7px", color: "#555", marginBottom: "2px" },
  referenciaNumero: { fontSize: "8px", marginBottom: "8px" },
  vigencia: { fontSize: "7px", color: "#8A4B10", marginTop: "-6px", marginBottom: "8px" },
});

const PdfExternos = ({ name, matricula, idPlantel, nombrePlantel, concepto, referenciaBanorte, referenciaBBVA, precio, folioTPV, fechaVencimiento }) => {
  const stringPlantel = String(idPlantel).padStart(2, "0");
  
  const precioFormateado = Number(precio).toLocaleString('es-MX', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });

  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <Image src={ficha} style={styles.back} />

        <Text style={styles.name}>{name}</Text>
        <Text style={styles.campus}>{stringPlantel} {nombrePlantel}</Text>
        <Text style={styles.code}>{matricula}</Text>
        
        {/* Mostramos ambos convenios en la imagen */}
        <Text style={styles.convenioBBVA}>CIE: 1806998</Text> 
        <Text style={styles.convenioBanorte}>Servicio 5446</Text>

        <View style={styles.section}>
          <View style={styles.section2Titles}>
            <Text style={styles.concepto}>Concepto</Text>
            {/* Cambiamos el título a plural */}
            <Text style={{ width: "7cm" }}>Referencias</Text>
            <Text style={styles.precio}>Monto</Text>
          </View>

          <View style={styles.section2}>
            <Text style={styles.concepto}>{concepto}</Text>
            
            <View style={styles.referenciasContenedor}>
              
              <Text style={styles.bancoTitulo}>BANORTE:</Text>
              <Text style={styles.referenciaNumero}>{referenciaBanorte}</Text>
              {fechaVencimiento ? (
                <Text style={styles.vigencia}>Vigente hasta el {fechaVencimiento}</Text>
              ) : null}
              
              <Text style={styles.bancoTitulo}>BBVA:</Text>
              <Text style={styles.referenciaNumero}>{referenciaBBVA}</Text>
              {folioTPV ? (
                <>
                  <Text style={styles.bancoTitulo}>TPV (Plantel):</Text>
                  <Text style={styles.referenciaNumero}>{folioTPV}</Text>
                </>
              ) : null}
            </View>

            <Text style={styles.precio}>${precioFormateado}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PdfExternos;